<template>
    <div>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>产品介绍</li>
                <li>API介绍</li>
            </ul>
        </div>
        <div class="mainindex">
            <div class="welinfo">
                <div style="text-align:center;">
                    <strong style="font-size: 18px;color:rgb(100, 164, 248)">API介绍</strong>
                </div>
                <!-- <div style="text-align:left;margin-left:20px;">
                    <b style="margin-left:20px;">云验证－通信云API开放平台是一款集短信、电话、语音短信、语音验证、传真、会议...于一体的通信API集成产品；</b>
                    <br>
                    <b style="margin-left:20px;">云验证api.2office.cn将语音、短信等通信能力及商务服务资源向互联网开发者、软件应用开发、社区运营者开放，为各类移动互联网创业者和创新性企业提供低门槛的各类通信能力服务，既方便又便宜，使合作伙伴可以像使用水、电那样“即开即有、按需取用”，在很短时间内构建出自己的业务或特色应用。让您跳过复杂冗长的运营商沟通谈判、设备投入、后期维护、客服等过程，直接关心您的核心应用及新增收入。</b>
                </div> -->
                <ul class="infolist">
                    <div style="text-align:left;">
                        <label style="font-size: 13px;margin-left:20px;">云验证－通信云API开放平台是一款集短信、电话、语音短信、语音验证、传真、会议...于一体的通信API集成产品；</label>
                        <br>
                        <label style="font-size: 13px;margin-left:20px;">云验证api.2office.cn将语音、短信等通信能力及商务服务资源向互联网开发者、软件应用开发、社区运营者开放，为各类移动互联网创业者和创新性企业提供低门槛的各类通信能力服务，既方便又便宜，使合作伙伴可以像使用水、电那样“即开即有、按需取用”，在很短时间内构建出自己的业务或特色应用。</label>
                        <br>
                        <label style="font-size: 13px;margin-left:20px;">让您跳过复杂冗长的运营商沟通谈判、设备投入、后期维护、客服等过程，直接关心您的核心应用及新增收入。</label>
                    </div>
                    <li>
                        <span>
                            如，您可以轻松创建：<br>
                            1、如网银或支付宝般的，用户注册或验证码快捷短信或语音下发<br>
                            2、或者调用API，或者直接嵌入方式，进行各项通信能力调用或运营<br>
                            除了开放通信云，我们还将开放商务云...<br>
                            未来您也可以将您好的业务、产品、资源能力等，反向接入到第二办室，与我们合作<br>
                            让更多的用户共享你的成果，努力一起打造一个稳定可靠的云服务平台 Yunfuwu.org<br>
                        </span>
                    </li>
                    <li style="clear: both;">
                        <img src="@/assets/images/gaishu-jieshao.png" style="float:left;margin-left:20px;"/>
                    </li>
                    <li style="clear: both;">
                        <b style="font-size: 13px;">1、接口的使用流程如下:</b>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（1）API详情请登录网站查看（用户需先在<a href="/reg" target="_blank" style="margin-left:-10px;">http://www.yanzhengma.cn</a> 上注册成云验证用户，填写详细资料、用途并上传证件）</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（2）您可以先 <a href="http://user.2office.cn/doc/smsapi" target="_blank" style="margin-left:-15px;">查看api文档</a> 需要申请联系客服。</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（3）开发需获得授权码及绑定IP，请联络客服，客服根据申请记录，会联系API使用者，并发放授权码给API使用客户</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（4）测试前请先在线少量充值，云验证不接受免费测试</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（5）API用户根据门牌号、密码、授权码使用自己所需要的API接口，测试对调</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（6）测试通过，正式启用API首次充值需不低于5000元（个人开发者或优秀应用、战略合作可予特别支持）</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（7）试用期内接口免费，试用结束部分API将适当收取年维护费用</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（8）特殊需求、订制开发需另行收费，欢迎宝贵建议，谢谢支持！</span>
                    </li>
                    <li>
                        <b style="font-size: 13px;color:red;">2、本平台试用中，特别申明：</b>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（1）你使用本平台或接口前，确认已经清楚并同意遵守用户协议</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（2）请勿违规使用，对恶意账户将即时冻结并举报到公安机关；</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（3）使用者对信息内容、号码、接收用户投诉承担全部责任，请妥善保管账户密码</span>
                    </li>
                    <li>
                        <span style="margin-left: 20px;">（3）API提交频度:有限制，建议不高于每秒5次，提交失败可重复提交，比如重复3次然后放弃；短信相同内容不同号码需打包发送，禁止单条提交；过快及频繁单条发送将会被限制优先级\直至关闭等</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="xline"></div>
    </div>
</template>

<script>
export default {
    methods:{
        open400() {
            window.open('http://4006.2office.cn/lkszjreo/wqi4rpo/ewirwed/qncyrq/oijoijfkiej.aspx', '800', '600');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shouye/productdescription/apiintroduction.vue